import React, { Component } from "react";
import { Form, Input, Button } from "antd";
import TrackedKeywordsCount from "../TrackedKeywords/TrackedKeywordsCount";
import ChangeRegionalDatabaseForm from "../TrackedKeywords/ChangeRegionalDatabaseForm";
import KeywordsTable from "../../containers/TrackedKeywords/KeywordsTable";

const InputGroup = Input.Group;
export class KeywordsTab extends Component {
  constructor(props) {
    super(props);

    this.state = {
      keyword: "",
      validationError: "",
    };

    this.onChangeSeoDb = this.onChangeSeoDb.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.isAddingTrackedKeywords && !this.props.isAddingTrackedKeywords) {
      this.setState({ keyword: "" });
    }
  }

  onChangeSeoDb(seoDb) {
    this.props.changeSeoDb(this.props.domain, seoDb);
  }

  handleInputChange(event) {
    let keyword = event.target.value;
    this.setState({ keyword, validationError: "" });
  }

  handleSubmit(event) {
    event.preventDefault();
    let keyword = this.state.keyword.toLowerCase().trim();
    if (!keyword) {
      this.setState({ keyword, validationError: "This field is required!" });
    } else {
      this.setState({ keyword, validationError: "" });
      this.props.addTrackedKeywords(this.props.domain, this.props.seoDb, [keyword]);
    }
  }

  render() {
    return (
      <div className="keywords-tab">
        <TrackedKeywordsCount
          isLoading={this.props.isFetchingKeywordsCount}
          keywordsCount={this.props.keywordsCount}
          maxKeywordsNo={this.props.maxKeywordsNo}
        />
        <ChangeRegionalDatabaseForm
          customClassName={"dashboard-settings-change-regional-db-form"}
          seoDb={this.props.seoDb}
          onSubmit={(newSeoDb) => this.onChangeSeoDb(newSeoDb)}
          regionalDatabases={this.props.regionalDatabases}
          isChangingSeoDb={this.props.isChangingSeoDb}
        />
        <div className="dashboard-settings-add-keyword-form">
          <p><strong>Custom keywords</strong></p>
          <Form onSubmit={this.handleSubmit}>
            <Form.Item
              validateStatus={this.state.validationError ? "error" : "success"}
              help={this.state.validationError}>
              <InputGroup compact size="large">
                <div className="compact-input-group">
                  <Input
                    name="keyword"
                    size="large"
                    value={this.state.keyword}
                    onChange={this.handleInputChange}
                    placeholder="Add new keyword"
                  />

                  <Button
                    type="primary"
                    htmlType="submit"
                    icon="plus"
                    size="large"
                    loading={this.props.isAddingTrackedKeywords}></Button>
                </div>
              </InputGroup>
            </Form.Item>
          </Form>
        </div>

        <KeywordsTable tableLocation={"dashboard_settings"} domain={this.props.domain} />

        <Button className="redirect-link" type="link" onClick={() => this.props.push("/keyword-position")}>
            Check keywords overview
          </Button>
        
      </div>
    );
  }
}

export default KeywordsTab;
